import { Box2d, StateNode, track } from '@tldraw/tldraw'
import { Measuring } from 'components/VisualStudioPlayground/Tools/SelectTool/childStates/Measuring'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { Outline } from './Outline'
import { MeasurementLines } from './MeasurementLines'

const isMeasuringTool = (tool: StateNode): tool is Measuring => {
  return tool.id === 'measuring'
}

export interface Props {
  selectedBounds: Box2d
}

export const MeasureMarks = track(({ selectedBounds }: Props) => {
  const editor = useEditor()
  const hoveredShape = editor.getHoveredShape()
  const selectedShape = editor.getOnlySelectedShape()
  const hoveredOverSelectedShape = hoveredShape && selectedShape && hoveredShape.id === selectedShape.id
  const measuringTool = editor.getStateDescendant('select.measuring')

  if (!hoveredShape || !selectedShape || hoveredOverSelectedShape || !measuringTool || !isMeasuringTool(measuringTool))
    return <Outline bounds={selectedBounds} />

  const hoveredBounds = editor.getShapePageBounds(hoveredShape)
  const position = measuringTool.position

  if (!hoveredBounds || position === 'none') return <Outline bounds={selectedBounds} />

  return (
    <>
      <Outline bounds={selectedBounds} />
      <Outline bounds={hoveredBounds} />
      <MeasurementLines selectedBounds={selectedBounds} hoveredBounds={hoveredBounds} position={position} />
    </>
  )
})
